import JavaScriptIcon from '../assets/images/js.png'
import HtmlIcon from '../assets/images/html-5.png'
import ReactIcon from '../assets/images/react.png'
import ReduxIcon from '../assets/images/redux.png'
import CssIcon from '../assets/images/css.png'
import MuiIcon from '../assets/images/mui.png'
import GraphqlIcon from '../assets/images/graphql.png'
import SassIcon from '../assets/images/sass.png'

export const Stack = [
  {
    icon: HtmlIcon,
    language: 'html5',
    ratingValue: 5
  },
  {
    icon: CssIcon,
    language: 'Css3',
    ratingValue: 5
  },
  {
    icon: JavaScriptIcon,
    language: 'JavaScript',
    ratingValue: 4.5
  },
  {
    icon: ReactIcon,
    language: 'React',
    ratingValue: 5
  },
  {
    icon: ReduxIcon,
    language: 'Redux',
    ratingValue: 4
  },
  {
    icon: SassIcon,
    language: 'sass',
    ratingValue: 4
  },
  {
    icon: MuiIcon,
    language: 'material ui',
    ratingValue: 4.5
  },
  {
    icon: GraphqlIcon,
    language: 'qraphql',
    ratingValue: 3.5
  }
  
]
